// payment.js

import backend from "../api";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const usePaymentCheck = () => {
  const { user } = useSelector((state) => state.auth);
  const history = useHistory();

  useEffect(() => {
    const checkPaymentMethod = async () => {
      try {
        const response = await backend.get(`/payment-method`, {
          params: { user: user.user._id },
        });
        
        const paymentMethods = response.data.paymentMethods;
        
        if (!paymentMethods || !paymentMethods.selectedPaymentType) {
          history.push("/payment-integration");
        }
      } catch (error) {
        console.error("Error checking payment method:", error);
        history.push("/payment-integration");
      }
    };

    if (user) {
      checkPaymentMethod();
    }
  }, [user, history]);

  return null; 
};

export default usePaymentCheck;
